import { CollectionShort } from "../types/Collection";
import { API_URL } from "../utils";
import { CategoryCard } from "../types/CategoriesCard";

export default async (id?: number): Promise<CategoryCard[]> => {
	const headers = new Headers();

	const result: CategoryCard[] = await (
		await fetch(`${API_URL}/userProfile/categoriesMap${id > 0 ? `?id=${id}` : ''}`, {
			credentials: "include",
		})
	).json();

	return result;
};
